import { createViewBuilder, generateBindings, View } from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import {
  ActionDetail,
  isEventMulti,
  SelectedDetail,
  SelectedEvent,
} from '@material/mwc-list/mwc-list-foundation.js';
import { ListItemBase } from '@material/mwc-list/mwc-list-item-base.js';
import '@material/mwc-list/mwc-list.js';
import { List as MdcList } from '@material/mwc-list/mwc-list.js';
import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

export class ListView extends View {
  activable = false;
  rootTabbable = false;
  multi = false;
  wrapFocus = false;
  itemRoles: string | null = null;
  innerRole: string | null = null;
  noninteractive = false;

  content: View[] = [];

  onSelected?: (detail: SelectedDetail, ...value: ListItemBase[]) => void =
    undefined;

  handleOnSelected(event: SelectedEvent) {
    if (isEventMulti(event)) {
      const selected = Array.from(event.detail.index).map(
        idx => (event.target as MdcList).items[idx]
      );
      this.onSelected?.(event.detail, ...selected);
    } else {
      const selected = (event.target as MdcList).items[event.detail.index];
      this.onSelected?.(event.detail, selected);
    }
  }

  onAction?: (value: ListItemBase) => void = undefined;

  handleOnAction(event: CustomEvent<ActionDetail>) {
    const selected = (event.target as MdcList).items[event.detail.index];
    this.onAction?.(selected);
  }

  get body() {
    const bindings = generateBindings(this, [
      'content',
      'onSelected',
      'handleOnSelected',
      'onAction',
      'handleOnAction',
    ]);
    const eventsBindings = generateBindings(this.events);

    return html`
      <mwc-list
        ${spread({ ...this.attrs, ...bindings, ...eventsBindings })}
        .view="${this}"
        style="${styleMap(this.styles)}"
        @selected=${(evnt: any) => this.handleOnSelected(evnt)}
        @action=${(evnt: any) => this.handleOnAction(evnt)}
      >
        ${this.content.map(el => el.body)}
      </mwc-list>
    `;
  }
}
export function List(...content: View[]) {
  return createViewBuilder(ListView).content(content);
}
List.View = ListView;
